var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownArrowIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "8px",
    viewBox: "0 0 12 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2C67AF83-A88B-440B-946F-97DF9DBA0078") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pages",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile-/-Road-Closed-(Open)",
    transform: "translate(-283.000000, -27.000000)",
    fill: "#0B7BFB"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Footer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "up_btn",
    transform: "translate(289.000000, 30.000000) rotate(-270.000000) translate(-289.000000, -30.000000) translate(274.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0125,15.3 L13.5,20.85 C13.3999998,20.9500002 13.29375,21 13.18125,21 C13.06875,21 12.9625002,20.9625 12.8625,20.8875 L12.1125,20.1375 C12.0375,20.0374998 12,19.9249998 12,19.8 C12,19.6750002 12.0375,19.575 12.1125,19.5 L16.575,15 L12.1125,10.5 C12.0375,10.425 12,10.3249998 12,10.2 C12,10.0750002 12.0375,9.96250019 12.1125,9.8625 L12.8625,9.1125 C12.9625002,9.0375 13.06875,9 13.18125,9 C13.29375,9 13.3999998,9.0375 13.5,9.1125 L19.0125,14.6625 C19.0875,14.7625002 19.125,14.8750002 19.125,15 C19.125,15.1249998 19.0875,15.2374998 19.0125,15.3375 L19.0125,15.3 Z",
    id: "up-arrow-icon"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowIcon);
export default __webpack_public_path__ + "static/media/down-arrow-icon.66cec56efbc022a1486910e15e231ac0.svg";
export { ForwardRef as ReactComponent };